import {
  ToastPayload,
  DELETE_TOAST,
  POP_TOAST,
  PUSH_TOAST
} from "./types";

export function deleteToast(id: string): ToastPayload {
  return {
    type: DELETE_TOAST,
    data: id
  };
}

export function removeToast(): ToastPayload {
  return {
    type: POP_TOAST,
    data: undefined
  };
}

export function pushToast(toast: any): ToastPayload {
  return {
    type: PUSH_TOAST,
    data: toast
  };
}

